import { Observable } from 'rxjs';
import { Component } from '@angular/core';
import { AppServerAPI } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';

@Component({
  selector: 'app-image-view',
  templateUrl: './image-view.component.html',
  styleUrls: ['./image-view.component.scss']
})
export class ImageViewComponent extends AbstractWidgetComponent {

  urlImage: string;

  constructor(private appServerAPI: AppServerAPI) {
    super();
  }

  onContextChange(contextChange: ContextChange) {

  }


  onSetElementAndContext() {
    console.log('onSetElementAndContext');
    this.loadOverview();
  }

  private getYardMap(mapName: string): Observable<any> {
    return this.appServerAPI.execute('/client/control/yardmap', mapName);
  }

  private loadOverview() {
    if (this.widgetReference != null && this.widgetReference.data.resourceUUID != null) {
      this.urlImage = '/client/resource/archive/' + this.widgetReference.data.resourceUUID;
    }
  }
}
